import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import GenericBasicInfo from "../../../../../../components/cards/GenericBasicInfo";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../../variables";
import PropTypes from "prop-types";
import { useQuery } from "@tanstack/react-query";
import { genericRequestErrorHandler } from "../../../../../../api";
import Loader from "../../../../../../components/Loader";
import { retrieveCarRentalVendor } from "../../../../../../api/Vendor/CarRental";
import _ from "lodash";
import { DateTime } from "luxon";
import VendorsDocuments from "../../../components/VendorsDocuments";
import ListPaymentTerms from "../../../components/paymentsTerms/ListPaymentTerms";
import TabStrip from "../../../../../../components/TabStrip";
import { CustomButton } from "../../../../../../components/CustomButton";
import VendorCARConfigLogsTab from "./VendorCARConfigLogsTab";
import DepositStatments from "../../../../CommonCRMModals/DepositStatmentss/DepositStatment";
import ProformaStatments from "../../../../CommonCRMModals/Proforma/List";
import { Price } from "../../../../../../components/Price";

const trueFalseMapping = {
  true: "Yes",
  false: "No",
};

const statusOptions = {
  "": "-----",
  AC: "Active",
  IN: "Inactive",
  CA: "Candidate",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DetailCarRentalVendorModal: { ...modalGenericStyles.modal },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    display: "grid",
    padding: variables.double_gap,
    minHeight: "30vh",
    maxHeight: "70vh",
    overflow: "auto",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: cardStyles.card,
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: variables.normal_gap,
  },
  [`@media ${variables.media.smallscreen}`]: {
    cardBody: { justifyContent: "center" },
    row: {
      gridTemplateColumns: "1fr 1fr",
    },
    tabs: { gridAutoFlow: "column", justifyContent: "center" },
    tabBtns: {
      fontSize: "small",
    },
  },
});
const DetailCarRentalVendorModal = ({ id, onClose }) => {
  const classes = styles();

  const [activeTab, setActiveTab] = useState("basicData");

  const menuTabs = {
    basicData: "Basic Data",
    paymentTerms: "Payment Terms",
    proforma: "Proforma Statment",
    creditStatments: "Credit Statements",
    documents: "Documents",
    logs: "Logs",
  };

  const { data: car, isLoading: retrieveLoading } = useQuery({
    queryKey: ["DetailVendorCar", id],
    queryFn: async () => await retrieveCarRentalVendor({ id: id }),
    onError: (error) => genericRequestErrorHandler(error),
  });

  const VendorDataCpl = [
    ["Vendor", null, _.get(car, "data.vendor", "").split("car__")[1] || "N/A"],
    [" Username", null, _.get(car, "data.vendor_data.username")],
    [" Password", null, _.get(car, "data.vendor_data.password")],
    [" Currency", null, _.get(car, "data.vendor_data.currency")],
    [" Access Token", null, _.get(car, "data.vendor_data.access_token")],
    [" Api URL", null, _.get(car, "data.vendor_data.api_url", "")],
    [" Api Key", null, _.get(car, "data.vendor_data.api_key")],
    ["Application Key", null, _.get(car, "data.vendor_data.application_key")],
  ];

  const basicDataCpl = [
    ["Id", "id"],
    ["Member", "member"],
    ["Market Type", "market_type"],
    [
      "Notify Amount",
      null,
      <Price
        currency={car?.data?.vendor_data?.currency}
        price={car?.data?.notify_amount}
      />,
    ],
    ["Config uid", null, _.get(car, "data.config_uid[0]", "") || "N/A"],
    ["Notes", "notes"],
    [
      "Payment Validation",
      null,
      _.get(trueFalseMapping, _.get(car, "data.payment_validation")),
    ],
    ["CXL Strategy Time", "cxl_strategy_time"],
    [
      "CXL Strategy Daysahead",
      null,
      _.get(car, "data.cxl_strategy_daysahead", []) === 0
        ? "0"
        : _.get(car, "data.cxl_strategy_daysahead"),
    ],
    [
      "Block Non Refundable",
      null,
      _.get(trueFalseMapping, _.get(car, "data.block_nonrefundable")),
    ],
    [
      "Status",
      null,
      _.get(statusOptions, _.get(car, "data.status", "") || "N/A"),
    ],
  ];
  const creatorData = [
    ["Creator", "creator"],
    [
      "Created",
      null,
      DateTime.fromISO(_.get(car, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];
  const editorData = [
    ["Last Editor", "last_editor"],
    [
      "Edited",
      null,
      DateTime.fromISO(_.get(car, "data.edited")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];
  const vendorContactData = [
    ["Title", "title"],
    ["First Name", "first_name"],
    ["Last Name", "last_name"],
    ["Email", "email"],
  ];

  return (
    <div
      id="DetailVendorCARModal"
      className={classes.DetailCarRentalVendorModal}>
      <div className={classes.modalCard}>
        <div className={classes.modalCardHeader}>
          <span>Car Rental Details</span>
        </div>
        <TabStrip
          tabs={Object.entries(menuTabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <div className={classes.modalCardBody}>
          {retrieveLoading ? (
            <Loader />
          ) : (
            <React.Fragment>
              {activeTab === "basicData" && (
                <React.Fragment>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Basic Data"}
                        cardInfo={basicDataCpl}
                        objectData={_.get(car, "data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Creator Data"}
                        cardInfo={creatorData}
                        objectData={_.get(car, "data", {})}
                      />
                      <GenericBasicInfo
                        header={"Editor Data"}
                        cardInfo={editorData}
                        objectData={_.get(car, "data", {})}
                      />
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Data"}
                        cardInfo={VendorDataCpl}
                        objectData={_.get(car, "data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Contact Data"}
                        cardInfo={vendorContactData}
                        objectData={_.get(
                          car,
                          "data.vendor_data.contact_details",
                          {}
                        )}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {activeTab === "paymentTerms" && (
                <ListPaymentTerms
                  showAddButton={true}
                  vendorId={_.get(car, "data.id")}
                />
              )}
              {activeTab === "proforma" && (
                <ProformaStatments
                  invalidationKey="DetailsSubAgentModal"
                  entityType="vendor"
                  entityData={_.get(car, "data", {})}
                />
              )}
              {activeTab === "creditStatments" && (
                <DepositStatments
                  invalidationKey="DetailVendorCar"
                  entityType="vendor"
                  entityData={_.get(car, "data", {})}
                />
              )}
              {activeTab === "documents" && (
                <VendorsDocuments
                  queryKey={`vendor_car_document`}
                  tags={[`vendor__${_.get(car, "data.id")}`]}
                  entityData={_.get(car, "data", {})}
                />
              )}
              {activeTab === "logs" && <VendorCARConfigLogsTab />}
            </React.Fragment>
          )}
        </div>
        <div className={classes.cardActions}>
          <CustomButton id="cancel" appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DetailCarRentalVendorModal.propTypes = {
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DetailCarRentalVendorModal;
